import Vue from 'vue'
import Vuex from 'vuex'

import configurations from './modules/configurations'
import snackbar from '@/store/modules/snackbar'
import loader from '@/store/modules/loader'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    configurations,
    snackbar,
    loader
  }
})
